// extracted by mini-css-extract-plugin
module.exports = {"details":"NFTDescriptionSection_details__TCseR","limitLines":"NFTDescriptionSection_limitLines__y6mF_","descBorder":"NFTDescriptionSection_descBorder__sNAbB"};